import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchHiredlyXContent } from "../../../redux/actions/company_action";
import {
  AdviceDetailsContainer,
  AdviceExcerpt,
  AdviceImageBanner,
  AdviceTitle,
  GridContainerStyled,
  GridTopicCardsContainer,
  LinkWrapper,
  TaglineTitle,
  Wrapper,
} from "./styles";

let query = `
    insightsTitle
    insightsSection {
      data {
        attributes {
        title
        metaTitle
        metaDescription
        excerpt
        slug
        coverImage {
          data {
            attributes {
              url
            }
          }
        }
        }   
      }
    }
  `;

export default function HXInsights() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = await dispatch(fetchHiredlyXContent(query));

    const { insightsTitle, insightsSection } = response || {};
    setSolutions(insightsTitle);
    setSolutionsCard(insightsSection?.data);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const AdviceCard = (blog) => {
    return (
      <>
        <LinkWrapper href={`/advice/${blog?.slug}`} target="_blank">
          <Wrapper>
            <AdviceImageBanner
              src={
                blog?.coverImage?.data?.attributes?.url ??
                `https://assets.wobbjobs.com/images/backgrounds/hiredly-jobs-malaysia-wobb-background-v1.png`
              }
              alt={blog?.title}
              loading={"lazy"}
            />

            <AdviceDetailsContainer>
              <AdviceTitle>{blog.title}</AdviceTitle>
              <AdviceExcerpt
                dangerouslySetInnerHTML={{ __html: blog.excerpt }}
              />
            </AdviceDetailsContainer>
          </Wrapper>
        </LinkWrapper>
      </>
    );
  };

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <TaglineTitle
        dangerouslySetInnerHTML={{ __html: solutions }}
      ></TaglineTitle>

      <GridTopicCardsContainer>
        {solutionsCard?.map((cards, cardIndex) => {
          const attrs = cards?.attributes;
          return <>{AdviceCard(attrs)}</>;
        })}
      </GridTopicCardsContainer>
    </GridContainerStyled>
  );
}
